import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AppRouter from "./router/AppRouter";
import "./assets/styles/global.scss";

const App = () => {
  return (
    <div className="App">
      <ToastContainer position="top-right" autoClose={3000} />
      <AppRouter />
    </div>
  );
};

export default App;
